import { createContext } from 'react';

const LoginInputContext = createContext(null);

export default LoginInputContext;
